import GlobalModal from "components/Modal";
import { useGlobalContext } from "contexts/GlobalContext";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Button from "reactstrap/lib/Button";
import DetailObligation from "../../../../components/DetailObligationForm";
import { getObligationById, deleteObligation } from "./actions";

function ObligationDetail({
	match: {
		params: { id, business }
	},
	history
}) {
	const { showModal, hideModal } = useGlobalContext();
	const { item, loading } = useSelector(state => state.obligationDetail);
	const dispatch = useDispatch();

	const handleDelete = () => {
		dispatch(
			deleteObligation(id, err => {
				console.log(err);
				if (err) {
					alert(String(err));
				} else {
					history.push(`/companies/${business}`);
				}
				hideModal();
			})
		);
	};

	useEffect(() => {
		dispatch(getObligationById(id));
	}, [dispatch]);

	if (!item) return null;

	return (
		<Container className="dashboard">
			<Row>
				<Col xs={12}>
					<Card>
						<CardBody>
							<Row className="justify-content-between align-items-center">
								<div className="card__title">
									<h5 className="bold-text">Detalhes da Obrigação</h5>
								</div>
								<div>
									<Button color="danger" onClick={showModal}>
										Excluir
									</Button>
									<Link to={`/companies/${business}/obligations/${id}/edit`}>
										<Button color="primary">Editar</Button>
									</Link>
								</div>
							</Row>
							<DetailObligation
								obligation={{
									...item
								}}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>
			<GlobalModal
				title="Deletar obrigação"
				onOk={handleDelete}
				loading={loading.delete}
			>
				<p>
					Tem certeza que deseja excluir esta obrigação? Essa ação é
					irreversível
				</p>
			</GlobalModal>
		</Container>
	);
}

export default ObligationDetail;
